import * as React from "react";

export default function BlackDecemberRules() {
  return (
    <div className="black-december-rules">
      <h3>Regras sobre a premiação</h3>
      <div className="rules-description">
        <p>
          Para todas as operações cadastradas na plataforma a partir 09/12/2019, o BTG Pactual dará um incentivo percentual. O cálculo será feito pela soma dos valores de
          todas as operações desembolsadas ou em assinatura de procuração, até 06/01/20220, multiplicadas pelo percentual connforme faixa de quantidade de operações expressas na
          tabela abaixo.
        </p>

        <div className="table-operations">
          <div className="row">
            <div className="col-4">
              <strong>Operações</strong>
            </div>
            <div className="col-20">
              <strong>Comissão extra sobre valor desembolsado</strong>
            </div>
          </div>

          <div className="percentage-operations">
            <div className="row">
              <div className="col-4">
                <strong>Até 2 precatórios</strong>
              </div>
              <div className="col-20">
                <strong>+0.50%</strong>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <strong>De 3 a 5 precatórios</strong>
              </div>
              <div className="col-20">
                <strong>+1.5%</strong>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <strong>De 6 a 9 precatórios</strong>
              </div>
              <div className="col-20">
                <strong>+3.0%</strong>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <strong>10 ou mais precatórios</strong>
              </div>
              <div className="col-20">
                <strong>+5.0%</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/welcome/black-december/BlackDecemberRules.tsx